import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeleteHighlightCourseShelf($id: Int!) {
    deleteHighlightCourseShelf(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteHighlightCourseShelf: {
    id?: number;
  };
}
